import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

const useSiteData = (server, lang, doFetch = false) => {
    const dispatch = useDispatch();
    const siteData = useSelector(state => state.siteData);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!doFetch || loading || siteData) return;

        setLoading(true);
        setError(null);

        dispatch.siteData.fetchSiteData({
            server,
            lang: lang.replace(/"/g, ''),
        })
            .then(() => {
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                setError(err);
            });
    }, [doFetch, dispatch, loading, server, lang, siteData]);

    return {siteData, loading, error};
};

export default useSiteData;
